import { render, staticRenderFns } from "./TheWelcomeFood.vue?vue&type=template&id=6e17e682&scoped=true&"
import script from "./TheWelcomeFood.vue?vue&type=script&lang=ts&"
export * from "./TheWelcomeFood.vue?vue&type=script&lang=ts&"
import style0 from "./TheWelcomeFood.vue?vue&type=style&index=0&id=6e17e682&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e17e682",
  null
  
)

export default component.exports